<template>
  <div class="catalogModels">
    <default-header :h2="$t('catalogModels.title')" />
    <back-btn></back-btn>

    <div class="innerContent">
      <preloader v-if="brandListLoadingStatus" />

      <h3
        class="text-center"
        v-if="!brandListLoadingStatus && brandsList.length === 0"
      >{{$t('testResult.noBatteryFound')}}</h3>
      <div v-if="brandsList.length > 0">
        <h6 class="testResult__title mt-2">{{$t('catalogModels.chooseUpBatteries')}}</h6>
        <div v-for="(brand, index) in brandsList" :key="index">
          <div
            @click="goToModelList(group, brand)"
            class="catalogModels__item mt-3"
            v-for="(group, index) in brand.groups"
            :key="index"
          >
            <div class="catalogModels__item-empty"></div>
            <div class="catalogModels__item-center">
              <img v-if="!group.image" src="../assets/battery_placeholder.png" alt />
              <img v-else :src="group.image" alt />
              <div class="catalogModels__item-center__name">{{ group.groupName }}</div>
            </div>
            <div class="catalogModels__item-arrow">
              <font-awesome-icon :icon="['fas', 'arrow-circle-right' ]" />
            </div>
          </div>
        </div>
      </div>

      <button
        @click="$router.push({name: 'AddOtherBatteryModel'})"
        class="btn btn-outline-primary btn-block w-75 mt-3 mb-3 ml-auto mr-auto"
      >
        <font-awesome-icon :icon="['fas', 'keyboard' ]" />
        <span style="padding-left:10px;">{{$t('otherBattery.title')}}</span>
      </button>
    </div>

    <bottom-navigation />
  </div>
</template>

<script>
import DefaultHeader from '../partials/DefaultHeader';
import BottomNavigation from '../partials/BottomNavigation';
import { mapActions, mapGetters } from 'vuex';
import Preloader from '../components/Preloader';
import BackBtn from '../components/BackBtn';
export default {
  name: 'CatalogModels',
  components: {
    DefaultHeader,
    BottomNavigation,
    Preloader,
    BackBtn
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      brandsList: 'getBrandsList',
      brandListLoadingStatus: 'getBrandListLoadingStatus'
    })
  },
  beforeMount() {
    this.$store.commit('setBrandList', []);
    this.fetchModelsList();
  },
  methods: {
    ...mapActions(['fetchModelsList']),
    goToModelList(model, brand) {
      this.$store.commit('setModelTypes', model);
      this.$store.commit('setActiveBrand', brand.manufacturer);
      this.$router.push({ name: 'CatalogModelList' });
    }
  }
};
</script>

<style scoped lang="scss">
</style>